module.exports = __webpack_public_path__ + "assets/img/alert-qes.e50f13f6.svg";